module.exports = __webpack_public_path__ + "static/media/1.c8ef401b.JPG";